import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-add-zone-admin',
  templateUrl: './add-zone-admin.component.html',
  styleUrls: ['./add-zone-admin.component.css']
})
export class AddZoneAdminComponent implements OnInit {
  public userName: any;
  public cnfPasw: any;
  public password: any;
  public mobile: any;
  public email: any;
  public createdBy: any;

  constructor(public admin: AdminServicesService,
    public router: Router,
    public toastr: ToastrService) {
    this.createdBy = localStorage.getItem('userDetails');
  }

  ngOnInit(): void {
  }

  submit() {
    if (!this.userName) {
      return this.toastr.error("UserName is Empty");
    } else if (!this.password) {
      return this.toastr.error("Password is Empty");
    } else if (!this.cnfPasw) {
      return this.toastr.error("Conform Password is Empty")
    } else if (this.password != this.cnfPasw) {
      return this.toastr.error("Password Mismatch");
    } else if (!this.email) {
      return this.toastr.error("Email is Empty");
    } else if (!this.mobile) {
      return this.toastr.error("Mobile is Empty")
    } else {
      let obj = {
        "userName": this.userName,
        "cnfPasw": this.cnfPasw,
        "password": this.password,
        "mobile": this.mobile,
        "email": this.email,
        "createdBy": `${this.createdBy.userId}`
      }
      this.admin.register(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.toastr.success(res.message);
          setTimeout(() => {
            this.reset();
          }, 200);
          
        } else {
          this.toastr.error(res.message);
        }
      }, (err) => {
        this.toastr.error(err);
      });
    }
  }

  reset() {
    this.userName = null;
    this.cnfPasw = null;
    this.password = null;
    this.email = null;
    this.mobile = null;
  }
}
